import { __assign, __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common';
// tslint:disable-next-line: max-line-length
import { DeprecatedBaseButton } from '../../primitives/deprecated-buttons/deprecated-base-button/base-button.comp';
import { Tooltip } from '../../primitives/tooltip/tooltip';
var key = 'action-button';
var ActionButton = /** @class */ (function (_super) {
    __extends(ActionButton, _super);
    function ActionButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionButton.prototype.render = function () {
        var props = this.props;
        var classNames = namespacedClassnames(key, props.className);
        return (
        // tslint:disable-next-line:max-line-length
        React.createElement(Tooltip, { body: props.disabled || props.description, className: classNames, relativeToBody: props.tooltipRelativeToBody },
            React.createElement(DeprecatedBaseButton, __assign({}, props, { disabled: !!props.disabled }), props.children)));
    };
    return ActionButton;
}(React.PureComponent));
export { ActionButton };
//# sourceMappingURL=action-button.js.map